<template>
  <div class="min-h-screen flex items-center justify-center p-6 bg-grid-pattern">
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div
        class="absolute -top-40 -right-40 w-80 h-80 bg-primary-500/20 rounded-full blur-3xl"
      ></div>
      <div
        class="absolute -bottom-40 -left-40 w-80 h-80 bg-accent-red/20 rounded-full blur-3xl"
      ></div>
      <div
        class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-accent-yellow/10 rounded-full blur-3xl"
      ></div>
    </div>

    <div class="relative w-full max-w-md">
      <div class="card p-8">
        <div class="text-center mb-8">
          <div
            class="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-primary-500 via-accent-red to-accent-yellow mb-4 shadow-lg shadow-primary-500/25"
          >
            <span class="text-white font-bold text-3xl font-display">P</span>
          </div>
          <h1 class="font-display text-3xl font-bold text-gradient">pushx.pro</h1>
          <p class="text-gray-400 mt-2">Восстановление пароля</p>
        </div>

        <div
          v-if="successMessage"
          class="mb-6 p-4 rounded-lg bg-green-500/10 border border-green-500/30"
        >
          <p class="text-sm text-green-400">{{ successMessage }}</p>
        </div>
        <div
          v-else-if="errorMessage"
          class="mb-6 p-4 rounded-lg bg-red-500/10 border border-red-500/30"
        >
          <p class="text-sm text-red-400">{{ errorMessage }}</p>
        </div>

        <form v-if="!successMessage" @submit.prevent="handleSubmit" class="space-y-5">
          <div>
            <label class="form-label">Email</label>
            <input
              v-model="form.email"
              type="email"
              class="input-field"
              placeholder="email@example.com"
              required
              autocomplete="email"
            />
            <div v-if="errors.email" class="mt-1 text-sm text-red-400">
              {{ errors.email }}
            </div>
          </div>

          <button
            type="submit"
            :disabled="loading"
            class="w-full btn-primary py-3 flex items-center justify-center gap-2 text-base font-semibold"
          >
            <svg
              v-if="loading"
              class="w-5 h-5 animate-spin"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            {{ loading ? 'Отправка...' : 'Отправить ссылку' }}
          </button>
        </form>

        <div class="mt-8 text-center space-y-2">
          <p class="text-sm text-gray-500">
            <button
              type="button"
              @click="$router.push('/login')"
              class="font-medium text-primary-500 hover:text-primary-400 transition-colors duration-200"
            >
              ← Вернуться к входу
            </button>
          </p>
          <p class="text-sm text-gray-500">
            Нет аккаунта?
            <button
              type="button"
              @click="$router.push('/register')"
              class="font-medium text-primary-500 hover:text-primary-400 transition-colors duration-200 ml-1"
            >
              Зарегистрироваться
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '../stores/auth';
import { useNotifications } from '../composables/useNotifications';

export default {
  name: 'ForgotPassword',
  setup() {
    const authStore = useAuthStore();
    const { success, error } = useNotifications();
    return { authStore, success, error };
  },
  data() {
    return {
      form: { email: '' },
      errors: {},
      loading: false,
      errorMessage: '',
      successMessage: '',
    };
  },
  methods: {
    validateForm() {
      this.errors = {};
      if (!this.form.email) {
        this.errors.email = 'Введите email';
        return false;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.form.email)) {
        this.errors.email = 'Введите корректный email';
        return false;
      }
      return true;
    },
    async handleSubmit() {
      this.errorMessage = '';
      this.successMessage = '';
      if (!this.validateForm()) return;
      try {
        this.loading = true;
        const res = await this.authStore.forgotPassword(this.form.email);
        this.successMessage = res.data?.message || 'Ссылка для сброса пароля отправлена на ваш email.';
        this.success('Готово', this.successMessage);
      } catch (err) {
        this.errorMessage = err.response?.data?.message || 'Ошибка отправки. Попробуйте позже.';
        this.error('Ошибка', this.errorMessage);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
